import { render } from "./ViewImage.vue?vue&type=template&id=c9f1fa50&scoped=true"
import script from "./ViewImage.vue?vue&type=script&lang=js"
export * from "./ViewImage.vue?vue&type=script&lang=js"

import "./ViewImage.vue?vue&type=style&index=0&id=c9f1fa50&lang=css"
import "./ViewImage.vue?vue&type=style&index=1&id=c9f1fa50&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9f1fa50"]])

export default __exports__